<template>
	<div>
		<div class="canvas-wrapper" :style="'height:' + wheight + 'px'">
			<!-- 底图 -->
			<img :src="bgimg" class="bgimg" id="bgimg" :width="pwidth" :height="pheight" />

			<!-- 打印 canvas -->
			<canvas id="printCanvas" class="canvas"></canvas>
			<canvas id="myCanvas" class="canvas" :class="{show: showDashBorder && this.dragArr.length > 0}"></canvas>
			<canvas id="upCanvas" class="upcanvas"></canvas>

			<!-- 虚线框 -->
			<div class="dash-border" :style="{width: pwidth + 'px',height: pheight + 'px'}"></div>
			<!-- 框图  -->
			<div class="up-box" ref="wrapCanvas"
				:style="{backgroundImage: 'url(' + upimg + ')',backgroundSize: 'auto ' + frameH + 'px ',height: wheight + 'px',marginLeft: whiteScopeW + 'px',marginTop: whiteScopeT + 'px'}"
				@touchstart="start($event)" @touchmove="move($event)" @touchend="end($event)">
				<!-- 添加图片 -->
				<div class="add-img" v-show="dragArr.length <= 0 && !hidePhotoUpload" @click="chooseImg"></div>
			</div>

			<!-- 区域红字提示 -->
			<p class="move-tips" v-show="showDashBorder && dragArr.length > 0">
				{{ $t("C.Tips") }}{{ $t("C.Tips2") }}
			</p>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
	var WIDTH = 0; // myCanvas画布宽
	var HEIGHT = 0; // myCanvas画布高
	var PWIDTH = 0; // 手机模型宽
	var PHEIGHT = 0; // 手机模型高
	var c2, ctx2, c, ctx, printC, printCtx;
	var delIcon = new Image();
	var scaleIcon = new Image();
	var routeIcon = new Image();
	var bimg = new Image();
	var istouch = false;
	var canvasRatio = 1;
	class DragImg {
		constructor(props, canvas) {
			this.x = props.x;
			this.y = props.y;
			this.ux = props.ux;
			this.uy = props.uy;
			this.w = props.width;
			this.h = props.height;
			this.initw = props.initW;
			this.inith = props.initH;
			this.minW = props.minW;
			this.minH = props.minH;
			this.url = props.url;
			this.fontsize = props.fontsize;
			this.fontfamily = props.fontfamily;
			this.fillstyle = props.fillstyle;
			this.filltext = props.filltext;
			this.type = props.type;
			this.picType = props.picType;
			this.ctx = canvas;
			this.rotate = props.rotate;
			this.selected = props.selected;
			this.index = props.index;
			this.picId = props.picId;
			this.scale = props.scale;
			this.lockEdit = props.lockEdit || false; // 锁定图片：禁止移动/缩放/旋转，仅保留显示
			this.supportTextEdit = props.supportTextEdit === false ? false : true;
			this.supportGraphicDrag = props.supportGraphicDrag === false ? false : true;
		}

		// 对图片元素进行处理
		async paint() {
			ctx.save();
			ctx2.save();
			printCtx.save();
			this.centerX = this.x * canvasRatio + (this.w * canvasRatio) / 2;
			this.centerY = this.y * canvasRatio + (this.h * canvasRatio) / 2;

			// 旋转元素
			ctx.translate(this.centerX, this.centerY);
			ctx.rotate((this.rotate * Math.PI) / 180);
			ctx.translate(-this.centerX, -this.centerY);

			printCtx.translate(this.centerX, this.centerY);
			printCtx.rotate((this.rotate * Math.PI) / 180);
			printCtx.translate(-this.centerX, -this.centerY);

			let c3 = document.createElement("canvas");
			let ctx3 = c3.getContext("2d");
			let cwidth = WIDTH * canvasRatio;
			let cheight = HEIGHT * canvasRatio;
			c3.width = cwidth;
			c3.height = cheight;
			c3.style.opacity = 0;
			c3.style.width = WIDTH + "px";
			c3.style.height = HEIGHT + "px";

			let centeruX = this.ux * canvasRatio + (this.w * canvasRatio) / 2;
			let centeruY = this.uy * canvasRatio + (this.h * canvasRatio) / 2;

			// 渲染元素 0-图片 1-文字
			if (this.type === 0) {
				let imgWidth = this.w * canvasRatio;
				let imgheight = this.h * canvasRatio;
				ctx.drawImage(
					this.url,
					this.x * canvasRatio,
					this.y * canvasRatio,
					imgWidth,
					imgheight
				);

				printCtx.drawImage(
					this.url,
					this.x * canvasRatio,
					this.y * canvasRatio,
					imgWidth,
					imgheight
				);

				ctx3.translate(centeruX, centeruY);
				ctx3.rotate((this.rotate * Math.PI) / 180);
				ctx3.translate(-centeruX, -centeruY);

				ctx3.drawImage(
					this.url,
					this.ux * canvasRatio,
					this.uy * canvasRatio,
					imgWidth,
					imgheight
				);

				// 显示层图标和虚线
				this.drawIcon(this, ctx3);
				let pat = ctx2.createPattern(c3, "no-repeat");
				ctx2.fillStyle = pat;
				ctx2.fillRect(0, 0, PWIDTH * canvasRatio, PHEIGHT * canvasRatio);
				ctx3.clearRect(0, 0, c3.width, c3.height);
			} else {
				this.fontsize = this.h * canvasRatio;
				ctx.font = this.fontsize + "px " + this.fontfamily;
				ctx.fillStyle = this.fillstyle;
				ctx.textBaseline = "top";
				ctx.textAlign = "left";
				ctx.fillText(this.filltext, this.x * canvasRatio, this.y * canvasRatio);
				printCtx.font = this.fontsize + "px " + this.fontfamily;
				printCtx.fillStyle = this.fillstyle;
				printCtx.textBaseline = "top";
				printCtx.textAlign = "left";
				printCtx.fillText(this.filltext, this.x * canvasRatio, this.y * canvasRatio);
				this.w = ctx.measureText(this.filltext).width / canvasRatio;

				// 添加显示层
				ctx2.translate(centeruX, centeruY);
				ctx2.rotate((this.rotate * Math.PI) / 180);
				ctx2.translate(-centeruX, -centeruY);
				ctx2.textBaseline = "top";
				ctx2.textAlign = "left";
				ctx2.font = this.fontsize + "px " + this.fontfamily;
				ctx2.fillStyle = this.fillstyle;
				ctx2.fillText(
					this.filltext,
					this.ux * canvasRatio,
					this.uy * canvasRatio
				);
				ctx2.globalCompositeOperation = "source-atop";
				// 显示层绘制图标和虚线
				this.drawIcon(this, ctx2);
			}

			// 如果是选中状态，绘制选择虚线框，和缩放图标、删除图标
			this.drawIcon(this, null);
			c.style.zIndex = "5";
			c.style.opacity = 1;
			printC.style.zIndex = "5";
			printC.style.opacity = 1;
			ctx.restore();
			ctx2.restore();
			printCtx.restore();
		}

		// 手指操作的位置
		isInWhere(x, y) {
			// 变换区域左上角的坐标和区域的高度宽度
			const transformW = 24;
			const transformH = 24;
			let transformX = this.x + this.w;
			let transformY = this.y + this.h;
			this.centerX = this.centerX / canvasRatio;
			this.centerY = this.centerY / canvasRatio;
			const transformAngle = (Math.atan2(transformY - this.centerY, transformX - this.centerX) / Math.PI) * 180 +
				this.rotate;
			const transformXY = this.getTransform(
				transformX,
				transformY,
				transformAngle
			);
			transformX = transformXY.x;
			transformY = transformXY.y;

			// 删除区域左上角的坐标和区域的高度宽度
			const delW = 24;
			const delH = 24;
			let delX = this.x;
			let delY = this.y;
			const delAngle =
				(Math.atan2(delY - this.centerY, delX - this.centerX) / Math.PI) * 180 +
				this.rotate;
			const delXY = this.getTransform(delX, delY, delAngle);
			delX = delXY.x;
			delY = delXY.y;

			// 右上
			const angleW = 24;
			const angleH = 24;
			let rightX = this.x + this.w;
			let rightY = this.y;
			let rightAngle =
				(Math.atan2(rightY - this.centerY, rightX - this.centerX) / Math.PI) *
				180 +
				this.rotate;
			let rightXY = this.getTransform(rightX, rightY, rightAngle, 0, 0);
			rightX = rightXY.x;
			rightY = rightXY.y;

			// 左下
			let leftdX = this.x;
			let leftdY = this.y + this.h;
			let leftdAngle =
				(Math.atan2(leftdY - this.centerY, leftdX - this.centerX) / Math.PI) *
				180 +
				this.rotate;
			let leftdXY = this.getTransform(leftdX, leftdY, leftdAngle, 0, 0);
			leftdX = leftdXY.x;
			leftdY = leftdXY.y;

			// 移动区域的坐标
			let v1 = [delX + 12 - x, delY + 12 - y];
			let v2 = [rightX - x, rightY - y];
			let v3 = [leftdX - x, leftdY - y];
			let v4 = [transformX + 12 - x, transformY + 12 - y];

			if (
				x - transformX >= 0 &&
				y - transformY >= 0 &&
				transformX + transformW - x >= 0 &&
				transformY + transformH - y >= 0
			) {
				// 缩放区域
				return "transform";
			} else if (
				x - delX >= 0 &&
				y - delY >= 0 &&
				delX + delW - x >= 0 &&
				delY + delH - y >= 0
			) {
				// 删除区域
				return "del";
			} else if (
				x - rightX >= 0 &&
				y - rightY >= 0 &&
				rightX + angleW - x >= 0 &&
				rightY + angleH - y >= 0
			) {
				// 旋转区域
				return "Angle";
			} else if (
				v1[0] * v2[1] - v2[0] * v1[1] > 0 &&
				v2[0] * v4[1] - v4[0] * v2[1] > 0 &&
				v4[0] * v3[1] - v3[0] * v4[1] > 0 &&
				v3[0] * v1[1] - v1[0] * v3[1] > 0
			) {
				// 移动区域
				return "move";
			}
			// 不在选择区域里面
			return false;
		}

		getTransform(x, y, rotate) {
			// 将角度化为弧度
			var angle = (Math.PI / 180) * rotate;
			// 初始坐标与中点形成的直线长度不管怎么旋转都是不会变的，用勾股定理求出然后将其作为斜边
			var r = Math.sqrt(
				Math.pow(x - this.centerX, 2) + Math.pow(y - this.centerY, 2)
			);
			// 斜边乘sin值等于即可求出y坐标
			var a = Math.sin(angle) * r;
			// 斜边乘cos值等于即可求出x坐标
			var b = Math.cos(angle) * r;
			// 目前的xy坐标是相对于图片中点为原点的坐标轴，而我们的主坐标轴是canvas的坐标轴，所以要加上中点的坐标值才是标准的canvas坐标
			return {
				x: this.centerX + b - 12,
				y: this.centerY + a - 12,
			};
		}

		// 绘制图标和虚线
		drawIcon(sprite, ct) {
			let x, y, ctx;
			if (sprite.selected) {
				if (ct === null) {
					x = sprite.x * canvasRatio;
					y = sprite.y * canvasRatio;
					ctx = sprite.ctx;
				} else {
					x = sprite.ux * canvasRatio;
					y = sprite.uy * canvasRatio;
					ctx = ct;
				}
				let swidth = sprite.w * canvasRatio;
				let sheight = sprite.h * canvasRatio;

				let radius = 12 * canvasRatio;
				let iconWidth = 24 * canvasRatio;

				ctx.setLineDash([2, 5]);
				ctx.lineWidth = 2;
				ctx.strokeStyle = "#999999";
				ctx.lineDashOffset = 10;
				ctx.strokeRect(x, y, swidth, sheight);

				ctx.drawImage(delIcon, x - radius, y - radius, iconWidth, iconWidth);
				// 锁定图片(禁止图形拖拽)不显示缩放手柄
				if (!sprite.lockEdit) {
					ctx.drawImage(scaleIcon, x + swidth - radius, y + sheight - radius, iconWidth, iconWidth);
				}

				// 旋转角度按钮
				//ctx.drawImage(routeIcon, x + swidth - radius, y - radius, iconWidth, iconWidth);

			}
		}
	}

	export default {
		name: "diyCanvas",
		components: {},
		props: {
			// 添加的定制数组（图片，文字）
			spriteArr: {
				type: Array,
				default () {
					return [];
				},
			},

			// 底色图颜色（默认白底）
			materialsColorValue: {
				type: String,
				default: "",
			},

			// 底图
			bgimg: {
				type: String,
				default: "",
			},

			// 框图
			upimg: {
				type: String,
				default: "",
			},

			// 缩放后的底图宽
			pwidth: {
				type: Number,
				default: 0,
			},

			// 缩放后的底图长
			pheight: {
				type: Number,
				default: 0,
			},

			// 屏幕画布可操作长
			wheight: {
				type: Number,
				default: 0,
			},

			// 底图宽mm
			mw: {
				type: Number,
				default: 0,
			},

			// 底图长mm
			mh: {
				type: Number,
				default: 0,
			},

			// 底图宽mm ---
			nw: {
				type: Number,
				default: 0,
			},

			// 底图长mm ---
			nh: {
				type: Number,
				default: 0,
			},

			// 左移
			whiteScopeW: {
				type: Number,
				default: 0,
			},

			// 上移
			whiteScopeT: {
				type: Number,
				default: 0,
			},

			// 机型宽
			frameW: {
				type: Number,
				default: 0,
			},

			// 机型高
			frameH: {
				type: Number,
				default: 0,
			},

			// 水平翻转
			flipHorizontal: {
				type: Boolean,
				default: false
			},

			// 垂直翻转
			flipVertical: {
				type: Boolean,
				default: false
			},

			// 是否隐藏「添加图片」入口（开启图库扩展字段功能的客户不提供私人相册上传）
			hidePhotoUpload: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				ctx: null,
				dragArr: [], // 图形数组
				clickedkArr: [], // 选中
				c: null,
				lastImg: null,
				initial: null,
				startTouch: null,
				page: null,
				diffX: 0,
				diffY: 0,
				scale: 0,
				difScale: 0,
				imgDpi: 0,
				ratio: 0,
				isDown: false,
				isDrag: false, // 图片类型是否可编
				naturalWidth: 0, // 图片原像素
				naturalHeight: 0, // 图片原像素
				naturalSize: 0, // 计算图片Dpi的尺寸
				dpiType: 0, // type = 1 情况按宽计算，type = 2 情况按长计算
				showDashBorder: true, // 是否显示虚线框
				curTimeout: "", // 编辑器隐藏定时器
				upImg: "", // 框图
				// 删除Icon
				delIcon: "data:image/png;base64,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",
				// 缩放Icon
				scaleIcon: "data:image/png;base64,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",
				// 旋转Icon
				routeIcon: "data:image/png;base64,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"
			};
		},
		mounted() {
			// 删除Icon
			delIcon.src = this.delIcon;
			// 缩放Icon
			scaleIcon.src = this.scaleIcon;
			// 旋转Icon
			routeIcon.src = this.routeIcon;
			// 获取当前的屏幕像素密度比例
			canvasRatio = this.getPixelRatio();
		},
		methods: {
			// 初始化画布
			initCanvas() {
				WIDTH = window.screen.width;
				HEIGHT = this.wheight;
				c = document.getElementById("myCanvas");
				ctx = c.getContext("2d");
				let cwidth = WIDTH * canvasRatio;
				let cheight = HEIGHT * canvasRatio;
				c.width = cwidth;
				c.height = cheight;
				c.style.width = WIDTH + "px";
				c.style.height = HEIGHT + "px";

				c2 = document.getElementById("upCanvas");
				ctx2 = c2.getContext("2d");
				c2.width = this.pwidth * canvasRatio;
				c2.height = this.pheight * canvasRatio;
				c2.style.width = this.pwidth + "px";
				c2.style.height = this.pheight + "px";

				printC = document.getElementById("printCanvas");
				printCtx = printC.getContext("2d");
				printC.width = cwidth;
				printC.height = cheight;
				printC.style.width = WIDTH + "px";
				printC.style.height = HEIGHT + "px";
			},

			// 画图
			draw() {
				this.isDrag = true;
				this.clear();
				if (this.dragArr.length > 0) {
					ctx2.save();
					PWIDTH = this.pwidth;
					PHEIGHT = this.pheight;
					bimg = document.getElementById("bgimg");
					ctx2.drawImage(
						bimg,
						0,
						0,
						PWIDTH * canvasRatio,
						PHEIGHT * canvasRatio
					);

					this.dragArr.forEach((item) => {
						item.paint();
					});
				}
			},

			// 手指操作开始
			start(e) {
				if (this.isDrag && this.dragArr.length > 0) {
					this.showDashBorder = true;
					clearTimeout(this.curTimeout);
					this.isDown = true;
					// 初始化一个数组用于存放所有被点击到的图片对象
					this.clickedkArr = [];
					let x, y;
					if (e === null || e.length === 0) return;
					if (e.touches.length === 1) {
						x = e.touches[0].pageX;
						y = e.touches[0].pageY;
					} else if (e.touches.length >= 2) {
						// 两指操作
						istouch = true;
						this.page = e.touches; // 得到第一组两个点
						x = e.touches[0].pageX;
						y = e.touches[0].pageY;
					}

					this.dragArr.forEach((item, index) => {
						let place = item.isInWhere(x, y - 30); // y-30
						item.place = place;
						item.index = index;
						// 先将所有的item的selected变为flase
						item.selected = false;
						if (place) {
							this.clickedkArr.push(item);
						} else {
							// 未选中
							this.$emit("clear", 0);
						}
					});
					let length = this.clickedkArr.length;
					if (length) {
						// cavans绘制的图片的层级是越来越高的，因此我们取这个数组的最后一项，保证取到的图片实例是层级最高的
						let lastImg = this.clickedkArr[length - 1];
						let type = this.dragArr[lastImg.index].type;
						// 将该实例的被选值设为true，下次重新绘制将绘制边框
						lastImg.selected = true;
						// 保存这个选中的实例
						this.lastImg = lastImg;

						// 如果是删除的话就移除
						if (lastImg.place === "del") {
							this.$emit("clear", type);
							this.dragArr.splice(lastImg.index, 1);
							// 重新绘制
							this.draw();
							return;
						}

						if (this.lastImg.picType === 0 || this.lastImg.picType === 1) {
							this.getImgDPI(lastImg);
						}

						// 保存这个实例的初始值，以后会用上
						this.initial = {
							initialX: lastImg.x,
							initialY: lastImg.y,
							initialH: lastImg.h,
							initialW: lastImg.w,
							initialuX: lastImg.ux,
							initialuY: lastImg.uy,
							initialRotate: lastImg.rotate
						};
					} else {
						this.$emit("clear", 0);
					}

					// 重新绘制
					this.draw();

					// 保存点击的坐标，move时要用
					this.startTouch = {
						pageX: x,
						pageY: y
					};
				}
			},

			// 手指操作移动
			move(e) {
				if (this.isDown && this.isDrag) {
					this.showDashBorder = true;
					clearTimeout(this.curTimeout);
					let x, y;
					let now = [];
					let start = [];
					if (e === null || e.length === 0) return;
					let startX, startY;
					let lastImg = this.lastImg;
					// 锁定图片：仅保留显示，禁止移动/缩放/旋转
					if (lastImg && lastImg.lockEdit) {
						return;
					}
					if (e.touches.length === 1 && lastImg) {
						x = e.touches[0].pageX;
						y = e.touches[0].pageY;
						let pageX = lastImg.centerX / canvasRatio;
						let pageY = lastImg.centerY / canvasRatio;
						startX = this.startTouch.pageX;
						startY = this.startTouch.pageY;
						now[0] = e.touches[0];
						now[1] = {
							pageX,
							pageY,
						};
						start[0] = this.startTouch;
						start[1] = {
							pageX,
							pageY,
						};
					} else if (e.touches.length >= 2 && istouch && lastImg) {
						// 两指操作, 得到第一组两个点
						startX = this.page[0].pageX;
						startY = this.page[0].pageY;
						now[0] = e.touches[0];
						now[1] = e.touches[1];
						start[0] = this.page[0];
						start[1] = this.page[1];
					}
					if (this.initial) {
						let {
							initialX,
							initialY,
							initialuX,
							initialuY
						} = this.initial;
						if (this.clickedkArr.length) {
							// 是否强制铺满血位
							let isAllPlace = false;
							if (this.lastImg.place === "move" && e.touches.length === 1) {
								if (Number(lastImg.picType) === 1 && isAllPlace) {
									// 强制铺满，限制移动范围
									let touchEvent = {
										x: x,
										y: y
									};
									let startTouch = {
										startX: startX,
										startY: startY
									};
									this.limitMove(touchEvent, this.initial, startTouch, lastImg);
								} else {
									lastImg.x = initialX + (x - startX);
									lastImg.ux = initialuX + (x - startX);
									lastImg.y = initialY + (y - startY);
									lastImg.uy = initialuY + (y - startY);
								}
							}
							if (this.lastImg.place === "transform" || (e.touches.length >= 2 && istouch)) {
								// 旋转
								if (Number(lastImg.picType) === 0 || Number(lastImg.picType) === 1 || !isAllPlace) {
									// 旋转部分
									let {
										initialRotate
									} = this.initial;
									// 旋转的角度
									let rotation = this.getAngle(now[0], now[1]) - this.getAngle(start[0], start[1]);
									lastImg.rotate = initialRotate + rotation;
								}

								// 缩放部分
								let touchEvent = {
									x: now[0],
									y: now[1]
								};
								let startTouch = {
									startX: start[0],
									startY: start[1]
								};
								this.limitScale(touchEvent, this.initial, startTouch, lastImg);

								if (this.lastImg.picType === 0 || this.lastImg.picType === 1) {
									this.getImgDPI(lastImg);
								}
							}
							// 每次移动的时候都画
							this.draw();
						}
					}
				}
			},

			// 手指操作结束
			end() {
				this.curTimeout = setTimeout(() => {
					this.showDashBorder = false;
				}, 3000);
				this.isDown = false;
				if (this.isDrag) {
					if (istouch) {
						istouch = false;
					}
					if (this.lastImg && this.lastImg.selected && this.lastImg.place !== "del") {
						let selIndex = this.lastImg.type === 0 ? null : this.lastImg.index;
						this.$emit("select", this.lastImg, selIndex);
					}
				}
			},

			// 获取距离
			getDistance(p1, p2) {
				let x = p2.pageX - p1.pageX;
				let y = p2.pageY - p1.pageY;
				return Math.sqrt(x * x + y * y);
			},

			// 获取角度
			getAngle(p1, p2) {
				let x = p1.pageX - p2.pageX;
				let y = p1.pageY - p2.pageY;
				return (Math.atan2(y, x) * 180) / Math.PI;
			},

			// 定制
			make() {
				console.log("--------------------------------make()");
				if (this.dragArr.length > 0) {
					this.clearMyCanvas();
					// 去除图标和虚线
					this.dragArr.forEach((item) => {
						if (item.selected) {
							item.selected = false;
						}
						item.paint();
					});

					// 剪切图片
					let cutImage = ctx.getImageData(
						c.width / 2 - (this.pwidth * canvasRatio) / 2,
						c.height / 2 - (this.pheight * canvasRatio) / 2,
						this.pwidth * canvasRatio,
						this.pheight * canvasRatio
					);

					let testC = document.createElement("canvas");
					let testCtx = testC.getContext("2d");
					testC.width = PWIDTH * canvasRatio;
					testC.height = PHEIGHT * canvasRatio;

					// 将截图内容转化base64
					testCtx.putImageData(
						cutImage,
						0,
						0,
						0,
						0,
						PWIDTH * canvasRatio,
						PHEIGHT * canvasRatio
					);

					let newImage = testC.toDataURL("image/png", 0.8);
					testCtx.clearRect(0, 0, PWIDTH * canvasRatio, PHEIGHT * canvasRatio);

					// 合并并导出文件
					this.compoundImg(newImage);
				} else {
					this.$message.warning(this.$t("C.PicTips"));
				}
			},

			// 合并并导出文件
			compoundImg(newImage) {
				//console.log("1、compoundImg");
				let nCanvas = document.createElement("canvas");
				let nCtx = nCanvas.getContext("2d");
				let nwidth = PWIDTH;
				let nheight = PHEIGHT;

				nCanvas.width = nwidth;
				nCanvas.height = nheight;

				// 开始执行画图出图任务
				Promise.all([
					this.loadImage(this.bgimg, 0),
					this.loadImage(newImage, 1),
					this.loadImage(this.upimg, 2)
				]).then((imgs) => {
					// 1、画底图
					nCtx.drawImage(imgs[0], 0, 0, nwidth, nheight);

					// 2、画合成图
					let scanvas = document.createElement("canvas");
					let sctx = scanvas.getContext("2d");
					scanvas.width = nwidth;
					scanvas.height = nheight;
					scanvas.style.opacity = 0;
					sctx.drawImage(imgs[1], 0, 0, nwidth, nheight);

					let pat = nCtx.createPattern(scanvas, "no-repeat");
					nCtx.fillStyle = pat;
					nCtx.fillRect(0, 0, nwidth, nheight);

					// 镜像翻转 -- 效果文件
					if (this.flipHorizontal) {
						let imgData = nCtx.getImageData(0, 0, nwidth, nheight);
						let newImgData = nCtx.getImageData(0, 0, nwidth, nheight);
						nCtx.putImageData(this.imageDataHRevert(newImgData, imgData), 0, 0);
					}
					if (this.flipVertical) {
						let imgData = nCtx.getImageData(0, 0, nwidth, nheight);
						let newImgData = nCtx.getImageData(0, 0, nwidth, nheight);
						nCtx.putImageData(this.imageDataVRevert(newImgData, imgData), 0, 0);
					}

					// 3、画框图
					let phoneK = this.frameW;
					let phoneG = this.frameH;

					// 计算要移动的距离
					let xX = nwidth / 2 - phoneK / 2;
					let yY = nheight / 2 - phoneG / 2;

					// console.log("左移 = " + this.whiteScopeW);
					// console.log("上移 = " + this.whiteScopeT);

					// 计算要额外移动的距离
					let xLeft = 0;
					let yTop = 0;

					// 往左边偏移的距离
					// xLeft = (this.whiteScopeW * nwidth) / this.pm2px(this.mw);
					// xLeft = 12;
					xLeft = 13.5;
					// console.log("缩放后的左移 = " + xLeft);

					// 往上边偏移的距离
					// yTop = (this.whiteScopeT * nheight) / this.pm2px(this.mh);
					// yTop = -5.5;
					yTop = -6.2;
					// console.log("缩放后的上移 = " + yTop);

					nCtx.drawImage(imgs[2], xX + xLeft, yY + yTop, phoneK, phoneG);

					// 4、裁剪图片
					let image = this.convertCanvasToImage(nCanvas);

					// 5、结束
					sctx.clearRect(0, 0, nwidth, nheight);
					nCtx.clearRect(0, 0, nwidth, nheight);

					let pdfImg = this.getCutImg(); // 剪切图
					if (pdfImg) {
						// image 效果文件   pdfImg 生产文件
						this.importFile(image, pdfImg);
					}
				}).catch((err) => {
					// 出图链路上任一图片加载/导出失败都会走到这里：必须复位 Loading，避免一直卡在生成中
					console.error("[diyCanvas] make failed:", err);
					this.$toast.fail("Image failed to load, please check your network and try again");
					this.$emit("handleLoading", false, "");
				});
			},

			// 导出图 image 效果文件   pdfImg 生产文件
			importFile(image, pdfimg) {
				//console.log("2、importFile");

				// base64转换成blob
				let _fileBlob = this.dataURLtoBlob(image.src);
				// blob转换成file文件
				let imgFile = new File([_fileBlob], new Date().getTime() + ".png");

				let pdfFile;
				// base64转换成blob
				let _fileBlob2 = this.dataURLtoBlob(pdfimg);
				// blob转换成file文件
				pdfFile = new File([_fileBlob2], new Date().getTime() + Math.round(Math.random() * 10) + ".png");

				// 上传文件
				let baseUrl = window.location.href;
				if (baseUrl.indexOf("print-h5.rockb2b.com") > 0) {
					this.uploadFile(imgFile, pdfFile, "hantu");
				} else {
					this.uploadFile(imgFile, pdfFile, "hantu_test");
				}
			},

			// 上传到桶子并返回
			uploadFile(img, pdf, name) {
				//console.log("3、uploadFile");
				let imgUrl, pdfUrl;

				// 随机命名
				let randomNameImg = this.random_string(6) + "_" + new Date().getTime() + "." + img.name.split(".").pop();
				let randomNamePDF = null;
				if (pdf !== null) {
					randomNamePDF = this.random_string(6) + "_" + new Date().getTime() + "." + pdf.name.split(".").pop();
				}
				// let accessKeyId = "LTAI4Ff77WX8MVBroUS1Gecf";
				// let accessKeySecret = "W3uFbWIeQNjnRePGBS1NxwPubZr0mx";
				let accessKeyId = "LTAI5tNCakDcr4TcB7PGtEu3";
				let accessKeySecret = "QQW0NptDxVrs2igcEs4ATRrF2IQFRF";
				let region = "oss-cn-shenzhen";
				let bucket = "rock-printer";
				let endpoint = "https://oss-accelerate.aliyuncs.com";
				//let hostname = "https://rock-printer.oss-accelerate.aliyuncs.com/";
				let hostname = "https://print-oss.rockb2b.com/";

				/* eslint-disable */
				let client = new OSS.Wrapper({
					region: region,
					accessKeyId: accessKeyId,
					accessKeySecret: accessKeySecret,
					bucket: bucket,
					endpoint: endpoint,
					secure: true
				});

				let currentDate = this.getCurrentDate();
				// 上传定制图片
				client
					.multipartUpload(
						"print-h5/" +
						name +
						"/" +
						currentDate +
						"/" +
						randomNameImg,
						img, {}
					)
					.then((results) => {
						imgUrl = hostname + results.name;
						console.log("imgUrl = " + imgUrl);
						// 上传pdf文件
						if (pdf !== null) {
							client
								.multipartUpload(
									"print-h5/" +
									name +
									"/" +
									currentDate +
									"/" +
									randomNamePDF,
									pdf, {}
								)
								.then((results2) => {
									if (results2.res.status === 200) {
										pdfUrl = hostname + results2.name;
										console.log("pdfUrl = " + pdfUrl);
										this.$emit("submit", imgUrl, pdfUrl);
									}
								})
								.catch((err) => {
									console.log(err);
								});
						}
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 处理生产文件
			getCutImg(imgUrl) {
				let fCanvas = document.createElement("canvas");
				let fCtx = fCanvas.getContext("2d");
				this.paintPrintImg(fCanvas, fCtx);
				let pdfImg = this.handlePdf(fCanvas, fCtx);
				return pdfImg;
			},

			// 处理打印图片
			paintPrintImg(fCanvas, fCtx) {
				let dx = 0;
				let dy = 0;
				// 手机的左上角坐标
				let phonex = c.width / canvasRatio / 2 - this.pwidth / 2;
				let phoney = c.height / canvasRatio / 2 - this.pheight / 2;
				this.imgDpi = 300;
				// 手机当前dpi的尺寸
				let phonew = (this.mw / 25.4) * this.imgDpi;
				let phoneh = (this.mh / 25.4) * this.imgDpi;

				fCanvas.width = phonew;
				fCanvas.height = phoneh;

				this.diffX = 0;
				this.diffY = 0;

				this.dragArr.forEach((item, index) => {
					fCtx.save();
					// 0-图片 1-文字
					if (item.type === 0) {
						// 需要绘制的宽高(px)，根据当前dpi计算
						let width = (item.url.naturalWidth / item.dpi) * this.imgDpi;
						let height = (item.url.naturalHeight / item.dpi) * this.imgDpi;
						// 图片缩放比例
						this.scale =
							((item.url.naturalWidth / item.dpi) * this.imgDpi) / item.w;
						// 判断放大还是缩小
						this.difScale = item.initw / item.w;
						dx = (item.x - phonex) * this.scale;
						dy = (item.y - phoney) * this.scale;

						fCtx.translate(dx + width / 2, dy + height / 2);
						fCtx.rotate((item.rotate * Math.PI) / 180);
						fCtx.translate(-(dx + width / 2), -(dy + height / 2));
						fCtx.drawImage(item.url, dx, dy, width, height);
					} else if (item.type === 1) {
						if (this.difScale === 0) {
							// 没有图片（第一个图层是文字），以底图为画布，计算缩放比例
							this.scale = phonew / bimg.width;
						}
						dx = (item.x - phonex) * this.scale;
						dy = (item.y - phoney) * this.scale;

						let ratio = item.w / item.h;
						// 需要绘制的宽高(px)
						let heightt = item.h * this.scale;
						fCtx.font = heightt + "px " + item.fontfamily;
						let widtht = fCtx.measureText(item.filltext).width;
						heightt = widtht / ratio;

						fCtx.translate(dx + widtht / 2, dy + heightt / 2);
						fCtx.rotate((item.rotate * Math.PI) / 180);
						fCtx.translate(-(dx + widtht / 2), -(dy + heightt / 2));

						fCtx.font = heightt + "px " + item.fontfamily;
						fCtx.fillStyle = item.fillstyle;
						fCtx.textBaseline = "top";
						fCtx.textAlign = "left";
						fCtx.fillText(item.filltext, dx, dy);
					}
					fCtx.restore();
				});
			},

			// 生产图处理
			handlePdf(fCanvas, fCtx) {
				let mwidth = 1200;
				let mheight = 2100;
				let wpx, hpx;
				wpx = mwidth;
				hpx = mheight;

				// 镜像翻转 -- 生产文件
				if (this.flipHorizontal) {
					let imgData = fCtx.getImageData(0, 0, wpx, hpx);
					let newImgData = fCtx.getImageData(0, 0, wpx, hpx);
					fCtx.putImageData(this.imageDataHRevert(newImgData, imgData), 0, 0);
				}
				if (this.flipVertical) {
					let imgData = fCtx.getImageData(0, 0, wpx, hpx);
					let newImgData = fCtx.getImageData(0, 0, wpx, hpx);
					fCtx.putImageData(this.imageDataVRevert(newImgData, imgData), 0, 0);
				}

				let cutImage = fCtx.getImageData(0, 0, wpx, hpx);

				// 将canvas的透明背景设置相应颜色
				if (this.materialsColorValue) {
					let colorArr = this.colorRgba(this.materialsColorValue);
					for (let i = 0; i < cutImage.data.length; i += 4) {
						// 当该像素是透明的,则设置成白色
						if (cutImage.data[i + 3] === 0) {
							cutImage.data[i] = colorArr[0];
							cutImage.data[i + 1] = colorArr[1];
							cutImage.data[i + 2] = colorArr[2];
							cutImage.data[i + 3] = 255;
						}
					}
				}
				fCtx.clearRect(0, 0, fCanvas.width, fCanvas.height);

				let tC = document.createElement("canvas");
				let tCtx = tC.getContext("2d");

				tC.width = mwidth;
				tC.height = mheight;
				let difX = 0;
				let difY = 0;
				let w = mwidth;
				let h = mheight;
				tCtx.putImageData(cutImage, 0, 0, difX, difY, w, h);

				// 将截图内容转化base64
				let newImage = tC.toDataURL("image/jpeg", 0.8);
				tCtx.clearRect(0, 0, wpx, hpx);

				return newImage;
			},

			// 横向镜像翻转
			imageDataHRevert(sourceData, newData) {
				for (var i = 0, h = sourceData.height; i < h; i++) {
					for (var j = 0, w = sourceData.width; j < w; j++) {
						newData.data[i * w * 4 + j * 4 + 0] =
							sourceData.data[i * w * 4 + (w - j) * 4 + 0];
						newData.data[i * w * 4 + j * 4 + 1] =
							sourceData.data[i * w * 4 + (w - j) * 4 + 1];
						newData.data[i * w * 4 + j * 4 + 2] =
							sourceData.data[i * w * 4 + (w - j) * 4 + 2];
						newData.data[i * w * 4 + j * 4 + 3] =
							sourceData.data[i * w * 4 + (w - j) * 4 + 3];
					}
				}
				return newData;
			},

			// 竖向镜像翻转
			imageDataVRevert(sourceData, newData) {
				for (var i = 0, h = sourceData.height; i < h; i++) {
					for (var j = 0, w = sourceData.width; j < w; j++) {
						newData.data[i * w * 4 + j * 4 + 0] =
							sourceData.data[(h - i) * w * 4 + j * 4 + 0];
						newData.data[i * w * 4 + j * 4 + 1] =
							sourceData.data[(h - i) * w * 4 + j * 4 + 1];
						newData.data[i * w * 4 + j * 4 + 2] =
							sourceData.data[(h - i) * w * 4 + j * 4 + 2];
						newData.data[i * w * 4 + j * 4 + 3] =
							sourceData.data[(h - i) * w * 4 + j * 4 + 3];
					}
				}
				return newData;
			},

			// 颜色转换
			colorRgba(str) {
				// 十六进制颜色值的正则表达式
				var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
				var sColor = str.toLowerCase();
				// 十六进制颜色转换为RGB格式
				if (sColor && reg.test(sColor)) {
					if (sColor.length === 4) {
						var sColorNew = "#";
						for (let i = 1; i < 4; i += 1) {
							// 例如：#eee,#fff等
							sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
						}
						sColor = sColorNew;
					}
					// 处理六位颜色值
					var sColorChange = [];
					for (let i = 1; i < 7; i += 2) {
						sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
					}
					return sColorChange;
				} else {
					return [0, 0, 0];
				}
			},

			// 获取图片dpi
			getImgDPI(item) {
				// 得到手机尺寸（英寸）
				let icw = this.mw / 25.4;
				let ich = this.mh / 25.4;
				// 得到缩放倍数
				let scalew = item.initw / item.w;
				let scaleh = item.inith / item.h;
				let scale = scalew > scaleh ? scaleh : scalew;
				let dpi = 0;
				if (item.url.naturalWidth / icw > item.url.naturalHeight / ich) {
					// 获取图片dpi和获取计算dpi的手机尺寸
					dpi = item.url.naturalHeight / ich;
					this.naturalSize = ich;
					this.dpiType = 2;
				} else {
					dpi = item.url.naturalWidth / icw;
					this.naturalSize = icw;
					this.dpiType = 1;
				}

				this.imgDpi = Math.round(dpi * scale);
				this.$set(item, "dpi", this.imgDpi);
				// 限制图片dpi不能过大，最大dpi 300
				this.limitImgDpi(scale, item);
				this.$emit("dpi", this.imgDpi, scale);
			},

			// type = 1 情况按宽计算，type = 2 情况按长计算
			limitImgDpi(scale, item) {
				this.naturalWidth = item.url.naturalWidth;
				this.naturalHeight = item.url.naturalHeight;
				if (this.imgDpi > 300) {
					// 超过300dpi时，取固定300dpi
					this.imgDpi = 300;
					if (this.dpiType === 1) {
						this.naturalWidth = (this.imgDpi / scale) * this.naturalSize;
						this.naturalHeight = item.url.naturalHeight * (this.naturalWidth / item.url.naturalWidth);
					} else {
						this.naturalHeight = (this.imgDpi / scale) * this.naturalSize;
						this.naturalWidth = item.url.naturalWidth * (this.naturalHeight / item.url.naturalHeight);
					}
				}
			},

			// 将base64转换为文件对象
			dataURLtoFile(dataurl, filename) {
				let arr = dataurl.split(",");
				let mime = arr[0].match(/:(.*?);/)[1];
				let bstr = atob(arr[1]);
				let n = bstr.length;
				let u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				// 转换成file对象
				return new File([u8arr], filename, {
					type: mime
				});
			},

			// base64转换成blob
			dataURLtoBlob(dataurl) {
				let arr = (dataurl || "").split(",");
				let mime = arr[0].match(/:(.*?);/)[1];
				let bstr = atob(arr[1]);
				let n = bstr.length;
				let u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {
					type: mime,
				});
			},

			// 随机生成文件名
			random_string(len) {
				len = len || 32;
				let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
				let maxPos = chars.length;
				let pwd = "";
				for (let i = 0; i < len; i++) {
					pwd += chars.charAt(Math.floor(Math.random() * maxPos));
				}
				return pwd;
			},

			// mm转px
			pm2px(d) {
				var iswindow = /windows|win32|win64/i.test(navigator.userAgent);
				if (iswindow) {
					return Math.round((d * 96) / 25.4);
				} else {
					return Math.round((d * 72) / 25.4);
				}
			},

			// px转mm
			px2pm(d) {
				var iswindow = /windows|win32|win64/i.test(navigator.userAgent);
				if (iswindow) {
					return Math.round((d * 25.4) / 96); // 电脑端
				} else {
					return Math.round((d * 25.4) / 72); // 手机端
				}
			},

			// 剪切图片
			convertCanvasToImage(canvas) {
				// 新Image对象
				let image = new Image();
				image.crossOrigin = "";
				let dataUrl = canvas.toDataURL("image/png", 0.8);
				image.src = dataUrl;
				return image;
			},

			// 加载图片（失败/超时会 reject，避免出图链路一直卡住）
			loadImage(url, index) {
				return new Promise((resolve, reject) => {
					if (!url) {
						reject(new Error("empty image url"));
						return;
					}
					let img = new Image();
					img.crossOrigin = "anonymous";
					let settled = false;
					let timer = null;
					const done = (fn, arg) => {
						if (settled) return;
						settled = true;
						if (timer) clearTimeout(timer);
						fn(arg);
					};
					// 兜底超时：跨境弱网下避免请求悬挂导致一直卡在生成中
					timer = setTimeout(() => done(reject, new Error("image load timeout")), 20000);
					img.onload = () => {
						// 加载失败时 img.complete 也可能为 true，需用 naturalWidth 判定
						if (!img.naturalWidth) {
							done(reject, new Error("image broken"));
							return;
						}
						done(resolve, img);
					};
					img.onerror = () => done(reject, new Error("image load error: " + url));
					if (index === 0 || index === 2) {
						img.src = url + "?t=" + new Date().getTime();
					} else {
						img.src = url;
					}
				});
			},

			// 获取年月日
			getCurrentDate() {
				let timeStr = "-";
				let curDate = new Date();
				let curYear = curDate.getFullYear();
				let curMonth = curDate.getMonth() + 1;
				let curDay = curDate.getDate();
				let Current = curYear + timeStr + curMonth + timeStr + curDay;
				return Current;
			},

			// 获取像素精度
			getPixelRatio() {
				let canvas = document.createElement("canvas");
				let context = canvas.getContext("2d");
				let backingStore =
					context.backingStorePixelRatio ||
					context.webkitBackingStorePixelRatio ||
					context.mozBackingStorePixelRatio ||
					context.msBackingStorePixelRatio ||
					context.oBackingStorePixelRatio ||
					context.backingStorePixelRatio ||
					1;
				return (window.devicePixelRatio || 1) / backingStore;
			},

			// 清空画布
			clear() {
				let canvas = document.getElementsByTagName("canvas");
				for (let i = 0; i < canvas.length; i++) {
					let ctx = canvas[i].getContext("2d");
					ctx.clearRect(0, 0, canvas[i].width, canvas[i].height);
				}
			},

			// 清空画布
			clearMyCanvas() {
				let canvas = document.getElementById("myCanvas");
				let ctx = canvas.getContext("2d");
				ctx.clearRect(0, 0, canvas.width, canvas.height);
			},

			// 限制移动范围
			limitMove(touchEvent, initial, startTouch, lastImg) {
				// 获取画布坐标
				let canvasPoint = this.getCanvasPoint();

				let {
					x,
					y
				} = touchEvent;
				let {
					initialX,
					initialuX
				} = initial;
				let {
					startX,
					startY
				} = startTouch;

				// 限制垂直移动范围
				this.handleMoveY(y, initial, startY, lastImg, canvasPoint);
				// 判断水平移动
				if (x - startX > lastImg.x - initialX) {
					// 右移
					lastImg.x = initialX + (x - startX);
					lastImg.ux = initialuX + (x - startX);

					// 判断图片左上角x是否跟画布左上角x重合
					if (canvasPoint.x1 - lastImg.x <= 0) {
						// 重合
						lastImg.x = canvasPoint.x1;
						lastImg.ux = initialuX + (canvasPoint.x1 - initialX);
					}
				} else if (x - startX < lastImg.x - initialX) {
					// 左移
					lastImg.x = initialX + (x - startX);
					lastImg.ux = initialuX + (x - startX);

					// 判断图片右上角x是否跟画布右上角x重合
					if (canvasPoint.x2 - lastImg.w - lastImg.x >= 0) {
						// 重合
						lastImg.x = canvasPoint.x2 - lastImg.w;
						lastImg.ux = initialuX + (canvasPoint.x2 - lastImg.w - initialX);
					}
				} else {
					lastImg.x = initialX + (x - startX);
					lastImg.ux = initialuX + (x - startX);
				}
			},

			// 限制垂直移动范围
			handleMoveY(y, initial, startY, lastImg, canvasPoint) {
				let {
					initialY,
					initialuY
				} = initial;
				// 判断垂直移动
				if (y - startY > lastImg.y - initialY) {
					// 下移
					lastImg.y = initialY + (y - startY);
					lastImg.uy = initialuY + (y - startY);

					// 判断图片左上角y是否跟画布左上角y重合
					if (canvasPoint.y1 - lastImg.y <= 0) {
						// 重合
						lastImg.y = canvasPoint.y1;
						lastImg.uy = initialuY + (canvasPoint.y1 - initialY);
					}
				} else if (y - startY < lastImg.y - initialY) {
					// 上移
					lastImg.y = initialY + (y - startY);
					lastImg.uy = initialuY + (y - startY);

					// 判断图片左下角y是否跟画布左下角y重合
					if (canvasPoint.y2 - lastImg.h - lastImg.y >= 0) {
						// 重合
						lastImg.y = canvasPoint.y2 - lastImg.h;
						lastImg.uy = initialuY + (canvasPoint.y2 - lastImg.h - initialY);
					}
				} else {
					lastImg.y = initialY + (y - startY);
					lastImg.uy = initialuY + (y - startY);
				}
			},

			// 限制缩放
			limitScale(touchEvent, initial, startTouch, lastImg) {
				// 获取画布坐标
				let canvasPoint = this.getCanvasPoint();

				let {
					x,
					y
				} = touchEvent;
				let {
					initialH,
					initialW,
					initialX,
					initialY,
					initialuX,
					initialuY
				} =
				initial;
				let {
					startX,
					startY
				} = startTouch;

				// 用勾股定理算出距离
				let lineA = this.getDistance(startX, startY);
				let lineB = this.getDistance(x, y);
				// 缩放后宽高
				let w = initialW + lineB - lineA;
				let h = initialH + (lineB - lineA) * (initialH / initialW); // 由于是等比缩放，所以乘一个宽高比例
				// 缩放后距离
				lastImg.linew = lineB - lineA;
				lastImg.lineh = (lineB - lineA) * (initialH / initialW);

				// 是否强制铺满血位
				let isAllPlace = false;
				// 获取最小缩放宽高
				let minW = isAllPlace ? lastImg.minW : 20;
				let minH = isAllPlace ? lastImg.minH : 20 * (lastImg.minW / lastImg.minH);
				// 判断当前缩放宽高是否大于最小宽高
				if (w > minW && h > minH) {
					// 大于，设置宽高/坐标值
					lastImg.w = w;
					lastImg.h = h;
					lastImg.x = initialX - lastImg.linew / 2;
					lastImg.ux = initialuX - lastImg.linew / 2;
					lastImg.y = initialY - lastImg.lineh / 2;
					lastImg.uy = initialuY - lastImg.lineh / 2;
				} else {
					// 小于或等于，设置为初始化值
					lastImg.w = minW;
					lastImg.h = minH;
				}

				if ((Number(lastImg.picType) === 0 || Number(lastImg.picType) === 1) && isAllPlace) {
					// 强制铺满血位，限制缩放范围
					this.handleScale(initial, lastImg, canvasPoint);
				}
			},

			// 限制缩放范围
			handleScale(initial, lastImg, canvasPoint) {
				let {
					initialX,
					initialY,
					initialuX,
					initialuY
				} = initial;

				if (canvasPoint.x1 - lastImg.x <= 0) {
					// 判断图片左上角x是否跟画布左上角x重合
					lastImg.x = canvasPoint.x1;
					lastImg.ux = initialuX + (canvasPoint.x1 - initialX);
				} else if (canvasPoint.x2 - lastImg.w - lastImg.x >= 0) {
					// 判断图片右上角x是否跟画布右上角x重合
					lastImg.x = canvasPoint.x2 - lastImg.w;
					lastImg.ux = initialuX + (canvasPoint.x2 - lastImg.w - initialX);
				}
				if (canvasPoint.y1 - lastImg.y <= 0) {
					// 判断图片左上角y是否跟画布左上角y重合
					lastImg.y = canvasPoint.y1;
					lastImg.uy = initialuY + (canvasPoint.y1 - initialY);
				} else if (canvasPoint.y2 - lastImg.h - lastImg.y >= 0) {
					// 判断图片左下角y是否跟画布左下角y重合
					lastImg.y = canvasPoint.y2 - lastImg.h;
					lastImg.uy = initialuY + (canvasPoint.y2 - lastImg.h - initialY);
				}
			},

			// 获取画布坐标
			getCanvasPoint() {
				// 获取画布中心点坐标
				let centerCX = window.screen.width / 2;
				let centerCY = this.$parent.wheight / 2;
				// 计算画布坐标
				return {
					centerCX: centerCX, // 画布中心点x
					centerCY: centerCY, // 画布中心点y
					x1: centerCX - this.pwidth / 2, // 左上角x
					x2: centerCX + this.pwidth / 2, // 右上角x
					y1: centerCY - this.pheight / 2, // 左上角y
					y2: centerCY + this.pheight / 2, // 左下角y
				};
			},

			// 上传本地图片
			chooseImg() {
				this.$emit("chooseImg");
			}
		},
		watch: {
			dragArr(arr) {
				arr.forEach((item, index) => {
					item.index = index;
				});
				return arr;
			},

			// 监听数组发生的变化
			spriteArr(arr) {
				this.initCanvas();
				if (arr.length > 0) {
					this.spriteArr = arr;
					// 获取最新添加的数据
					let newImg = arr.slice(-1)[0];
					let item = new DragImg(newImg, ctx);
					this.isDrag = true;
					if (this.isDrag) {
						// 判断，如果是图片则替换，文字判断是替换或者新添加
						this.dragArr.forEach((item, index) => {
							// 替换图片
							if (newImg.type === 0 && item.type === 0) {
								this.dragArr.splice(index, 1);
							}

							// 将最新之前的都设置成未选中
							if (index < this.dragArr.length) {
								item.selected = false;
							}

							// 修改文字
							if ((newImg.index === index) && item.type === 1) {
								this.dragArr.splice(index, 1);
							}
						});

						// 新增元素
						if (newImg.type === 0) {
							item.linew = 0;
							item.lineh = 0;
							this.dragArr.unshift(item);
							this.getImgDPI(item);
						} else {
							this.dragArr.push(item);
							this.$emit("select", item, this.dragArr.length - 1);
						}
						this.draw();
					}
				}
			},

			frameH(value) {
				this.frameH = value;
			},

			frameW(value) {
				this.frameW = value;
			},

			pwidth(value) {
				if (this.dragArr.length > 0) {
					this.dragArr.map((item) => {
						if (item.picType === 0 || item.picType === 1) {
							item.ux = item.ux - (PWIDTH - value) / 2;
							this.draw();
							this.getImgDPI(item);
						}
					});
				}
				this.pwidth = value;
				PWIDTH = value;
			},

			pheight(value) {
				if (this.dragArr.length > 0) {
					this.dragArr.map((item) => {
						if (item.picType === 0 || item.picType === 1) {
							item.uy = item.uy - (PHEIGHT - value) / 2;
						}
					});
				}
				this.pheight = value;
				PHEIGHT = value;
			},

			bgimg(value) {
				this.bgimg = value;
			},

			upimg(value) {
				this.upimg = value;
			},

			mw(value) {
				this.mw = value;
			},

			mh(value) {
				this.mh = value;
			}
		},
	};
</script>

<style lang="stylus" scoped>
	@import '~common/styles/variable.styl';
	@import '~common/styles/mixin.styl';

	.canvas-wrapper {
		position: relative;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;

		.bgimg,
		.print-t {
			position: absolute;
			left: 50%;
			top: 50%;
			background-repeat: no-repeat;
		}

		.bgimg {
			transform: translate3d(-50%, -50%, 0);
		}

		.print-t {
			z-index: 10;
			transform: translateY(-50%);
		}

		#myCanvas,
		#printCanvas {
			position: absolute;
			top: 0;
			left: 50%;
			transform: translateX(-50%);
			filter: opacity(0);
			z-index: 5;

			&.show {
				filter: opacity(0.3);
			}
		}

		.upcanvas {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate3d(-50%, -50%, 0);
			z-index: 8;
		}

		.up-box {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			background-repeat: no-repeat;
			background-position: 50% 50%;
			background-clip: content-box;
			z-index: 10;

			.icon {
				position: absolute;
				top: -10px;
				left: -10px;
				font-size: $font-xl;
				color: $color-font-white;
				background-color: $color-red;
				border-radius: 50%;
			}
		}

		.add-img {
			position: absolute;
			top: 51%;
			left: 47%;
			width: 80px;
			lineHeight(80px);
			align(center);
			border: 1px dashed $color-main;
			border-radius: $radius-sm;
			transform: translate3d(-50%, -50%, 0);
			background-color: rgbaMain(0.15);

			&::before,
			&::after {
				display: block;
				content: '';
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate3d(-50%, -50%, 0);
				background-color: $color-main;
				border-radius: 3px;
			}

			&::before {
				width: 2px;
				height: 60%;
			}

			&::after {
				width: 60%;
				height: 2px;
			}
		}

		.dash-border {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate3d(-50%, -50%, 0);
			border: 1px dashed $color-red;
			z-index: 9;
		}

		.move-tips {
			position: absolute;
			top: 0;
			left: 50%;
			width: 85%;
			line-height: 15px;
			font-size: 1.1rem;
			color: red;
			align(center);
			transform: translateX(-50%);
		}
	}
</style>
